module.exports = __webpack_public_path__ + "static/media/tpn-ce-mockup-1.c4370978.jpg";